(ns ycweb.app.website.voucher.create
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [clojure.string :as str]
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.voucher.common :as common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defn clean-email [email]
  (->
    email
    (str/replace #"\.{2,}" ".")
    (str/trim)
    (str/lower-case)))

(def email-validate
  #"(?i)^[A-Z0-9._%+!\"-]+@[A-Z0-9.-]+[.][A-Z]{2,}$")

;; PHP controllers/newvouchers.php parity for the PDF voucher message: FPDI
;; measures each line in Georgia 13.5pt on an mm page and rejects any line
;; wider than 125 mm. Glyph widths in 1/1000 em for code points 0-255, from
;; web-libs/fpdf/font/georgia.php ($cw). FPDF walks bytes, so anything outside
;; latin1 falls back to 1000 here, as FPDF does for unknown glyphs.
(def ^:private georgia-glyph-widths
  [1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000
   1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000 1000
   241 331 412 643 610 817 710 215 375 375 472 643 270 374 270 469
   614 430 559 552 565 528 566 502 596 566 313 313 643 643 643 479
   929 671 654 642 749 653 599 725 815 390 518 694 604 927 767 744
   610 744 702 561 619 756 667 976 710 615 602 375 469 375 643 643
   500 504 560 454 574 483 325 509 582 293 292 536 286 881 591 539
   571 560 410 432 345 575 497 737 505 492 444 430 375 430 643 1000
   642 1000 227 519 410 807 472 472 500 1206 561 415 998 1000 602 1000
   1000 227 227 410 410 393 643 857 500 942 432 415 816 1000 444 615
   241 331 555 622 571 615 375 500 500 942 500 581 643 374 942 500
   419 643 500 500 500 579 500 279 500 500 500 581 1050 1050 1050 479
   671 671 671 671 671 671 971 642 653 653 653 653 390 390 390 390
   749 767 744 744 744 744 744 643 744 756 756 756 756 615 614 548
   504 504 504 504 504 504 737 454 483 483 483 483 293 293 293 293
   532 591 539 539 539 539 539 643 539 575 575 575 575 492 559 492])

(def ^:private pdf-message-max-lines 8)
(def ^:private pdf-message-max-chars 300)
(def ^:private pdf-message-max-width-mm 125)

;; FPDF SetFontSize(13.5) on an mm page: FontSize = pt / (72 / 25.4)
(def ^:private pdf-message-font-size-mm (* 13.5 (/ 25.4 72)))

(defn pdf-message-lines
  "PHP explode(\"\\n\") parity: blank and trailing lines count as lines."
  [message]
  (str/split (or message "") #"\n" -1))

(defn pdf-line-width-mm
  "FPDF GetStringWidth parity: sum of glyph widths / 1000 * font size in mm."
  [line]
  (*
    (/ (reduce
         (fn [width ch]
           (+ width
             (nth georgia-glyph-widths
               #?(:clj (int ch) :cljs (.charCodeAt ch 0))
               1000)))
         0
         line)
      1000.0)
    pdf-message-font-size-mm))

(defn pdf-message-too-wide? [message]
  (boolean
    (some
      #(> (pdf-line-width-mm %) pdf-message-max-width-mm)
      (pdf-message-lines message))))

(defmethod grid/action :web.gift-vouchers/validation-pre-preivew [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)
        method (cmn/curact voucher-atom :voucher/method)
        cover (cmn/curact voucher-atom :voucher/cover)
        message (cmn/curact voucher-atom :voucher/message)
        qty (cmn/curact voucher-atom :voucher/qty)
        value (cmn/curact voucher-atom :voucher/value)
        valid-date? (:valid-date? config)
        valid-email (re-matches email-validate (clean-email (:email-valid config)))
        valid-duplicated-email (re-matches email-validate (clean-email (:confirm-email-valid config)))
        buyers-email
        (when (= "email" method)
          (re-matches email-validate (clean-email (:buyers-email config))))

        invalid-pdf-lines? (> (count (pdf-message-lines message)) pdf-message-max-lines)
        invalid-pdf-chars? (> (count message) pdf-message-max-chars)
        invalid-pdf-width (pdf-message-too-wide? message)

        invalid-total? (when value (> (* qty value) 20000))

        error-feedback
        (cond
          (nil? cover)
          "Please select a cover."

          (not valid-date?)
          "Please select a date in the future."

          (and (= method "pdf") invalid-pdf-lines?)
          "Your message can only be maximum 9 lines."

          (and (= method "pdf") invalid-pdf-chars?)
          "Your message can only be maximum 300 characters."

          (and (= method "pdf") invalid-pdf-width)
          "Your message is too wide. Please use more lines."

          (and (> qty 1) invalid-total?)
          "Maximum of R20 000 in total allowed, please reduce the quantity or amount. Contact us for larger amounts."

          invalid-total?
          "Maximum of R20 000 allowed. Contact us for larger amounts."

          (or (nil? value) (<= value 0))
          "Please enter a voucher value."

          (< value 5)
          "Minimum voucher amount is R5."

          (not (re-matches (re-pattern #"\d+") (str value)))
          "Enter only the number without decimals, e.g. 500"

          (or
            (nil? valid-email)
            (nil? valid-duplicated-email)
            (and
              (= method "email")
              (nil? buyers-email)))
          "Please make sure your email is in the correct layout."

          (not (= valid-email valid-duplicated-email))
          "Please make sure your emails match.")]

    (cond
      (and error-feedback cover)
      (do
        (swap! voucher-atom assoc :voucher/fail-validation-reason error-feedback)
        (scroll/scroll-to-id nil "js-display-validation-error"))

      error-feedback
      (urlstate/redirect app-atom "gift-vouchers" nil {})

      :else
      (do
        (swap! voucher-atom dissoc :voucher/fail-validation-reason)
        (urlstate/redirect app-atom "gift-vouchers" "previewvoucher"
          {:method method
           :coverid (:cover/id cover)})))))

(rum/defcs voucher-create < rum/reactive cmn/cursors (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)
        node-atom (::node-atom local-atom)

        {:voucher/keys
         [method fail-validation-reason message futuredate email voucher-id
          confirmemail buyeremail buyeremailcheck cover qty value] :as voucher}
        (rum/react voucher-atom)

        futuredate (when futuredate (ud/from-php-date futuredate))

        email? (= "email" method)

        valid-voucher-send-date?
        (or
          (= (:voucher/send voucher) "now")
          (and
            futuredate
            (dt/after? futuredate (dt/now))))

        invalid-pdf-width
        (when (and message (not email?))
          (pdf-message-too-wide? message))

        invalid-pdf-message?
        (when (and message (not email?))
          (or
            (> (count (pdf-message-lines message)) pdf-message-max-lines)
            (> (count message) pdf-message-max-chars)
            invalid-pdf-width))

        invalid-total? (when value (> (* qty value) 20000))]

    (when method
      [:<>
       [:div
        {:class (u/bem :yc-page-content [:standard])}
        (common/process-bar app-atom
          {:title "Create your voucher"
           :step 2
           :action "createvoucher"})

        [:div
         {:class (u/bem :yc-section [:standard])}
         [:form.form.u-block-center.u-max-width-480
          {:ref (fn [node] (reset! node-atom node))}

          (when (:ent/image cover)
            [:div.voucher-preview-image
             (if email?
               (web-common/lazy-image app-atom
                 (:doc/public-id (:ent/image cover))
                 {:class ["yc-simple-image  yc-simple-image--full"]}
                 {:w 480
                  :dpr 2
                  :c "lpad"
                  :q "auto"})
               (web-common/lazy-image app-atom
                 "pages/gift-vouchers/printed-voucher-preview.jpg"
                 {:class ["yc-simple-image  yc-simple-image--full"]}
                 {:h 410 :w 480 :c "scale"
                  :effect "distort:59:32:429:65:390:353:35:278"
                  :overlay (:doc/public-id (:ent/image cover))}))
             (buttons/button-web "Change"
               (merge
                 (urlstate/href-props app-atom
                   "gift-vouchers" "choosecover"
                   (u/maybe assoc
                     {:method method}
                     :voucherid voucher-id))
                 {:type :submit
                  :style :secondary
                  :size :small
                  :name "action"
                  :value "choosecover"
                  :icon :pencil
                  :icon-placement :right}))])

          [:div.flex-grid-content
           {:id "js-display-validation-error"}
           (when fail-validation-reason
             (feedback/feedback :error
               fail-validation-reason))]

          [:div
           (rum/with-key
             (forms/input "Voucher value (in ZAR Rand):" ""
               (cmn/cursor-in voucher-atom [:voucher/value])
               {:type :currency
                :name :value
                :id :value
                :required? true
                :error invalid-total?
                :hint
                (if invalid-total?
                  [[:b "Note: "] "Maximum of R20 000 allowed. Contact us for larger amounts."]
                  (list [:b "Note:"]
                    " Enter only the number without decimals, e.g. 500"))
                :class "u-max-width-160"})
             "voucher-value")]

          (rum/with-key
            (forms/select "Quantity" (cmn/cursor-in voucher-atom [:voucher/qty])
              (map
                (fn [v]
                  {:value v :text (str v)})
                (range 1 11))
              {:required? true
               :default 1
               :small-width true
               :error invalid-total?
               :hint
               (cond
                 (and qty (> qty 1) invalid-total?)
                 [[:b "Note: "] "Maximum of R20 000 in total allowed, please reduce the quantity or amount. Contact us for larger amounts."]

                 (and qty (> qty 1))
                 [:spen.text-status--info [:b "Note: "] qty " vouchers will be sent to recipient's email address"])})
            "voucher-quantity")

          (when email?
            [:div
             [:div
              (rum/with-key
                (forms/input "Recipient's email address:" "e.g. john.smith@domain.com"
                  (cmn/cursor-in voucher-atom [:voucher/email])
                  {:type :email
                   :name :email
                   :id :voucherrecipient
                   :required? true
                   :icon true
                   :hide-email-helpers true})
                "voucher-recipient")]

             [:div
              (rum/with-key
                (forms/input "Re-enter recipient's email address:" "Retype email above to confirm"
                  (cmn/cursor-in voucher-atom [:voucher/confirmemail])
                  {:type :email
                   :name :emailcheck
                   :id :confirmvoucherrecipient
                   :required? true
                   :icon true
                   :hide-email-helpers true})
                "confirm-voucher-recipient")]

             [:div
              (rum/with-key
                (forms/input "Your / Sender's name:" "e.g. Jane Smith"
                  (cmn/cursor-in voucher-atom [:voucher/name])
                  {:type :user
                   :name :name
                   :id :voucherfrom
                   :required? true
                   :icon true
                   :hide-email-helpers true
                   :hint (list [:b "Note:"] " Sender's name and will appear in the subject line")})
                "voucher-from")]])

          [:div
           {:style {:max-width "440px"}}
           (rum/with-key
             (forms/textarea "Your message: (optional)"
               (cmn/cursor-in voucher-atom [:voucher/message])
               (cond
                 email?
                 {:rows 9
                  :wrap "hard"}

                 :else
                 {:rows 9
                  :limit 300
                  :wrap "hard"
                  :warning? invalid-pdf-message?
                  :hint
                  (when-not email?
                    (list
                      [:b "Lines: "]
                      (- pdf-message-max-lines (count (pdf-message-lines message)))
                      " remaining" [:br]
                      [:b "Characters: "]
                      (- 300 (if (u/presence message) (count message) 0))
                      " remaining" [:br]
                      (when invalid-pdf-width [:b "Your message is too wide. Please use more lines."])))}))
             "voucher-message")]

          (when email?
            [:<>
             [:label
              {:class (u/bem :form-label [:set])}
              "Choose when to send voucher:"]
             [:div.form-field
              (rum/with-key
                (forms/radio "Send voucher now" "now"
                  (cmn/cursor-in voucher-atom [:voucher/send]))
                "send-now")]

             [:div.form-field
              (rum/with-key
                (forms/radio "Send voucher later" "future"
                  (cmn/cursor-in voucher-atom [:voucher/send]))
                "send-future")]

             (when
               (= "future" (:voucher/send voucher))

               [:div
                (rum/with-key
                  (forms/form-field
                    "Enter future date:" {}
                    (datepicker/datepicker app-atom "" "dd MMM YYYY"
                      [:web.gift-vouchers :voucher :voucher/futuredate]
                      {:hint
                       (list
                         [:b "Note:"]
                         " Your voucher will be scheduled and sent on this date.")
                       :header "Select date"
                       :required? true
                       :field-classes "flush"
                       :datatype :dateword}))
                  "futuredate")])])

          [:div
           (rum/with-key
             (forms/input "Your email address:" "e.g. jane.smith@domain.com"
               (cmn/cursor-in voucher-atom [:voucher/buyeremail])
               {:type :email
                :name :email
                :id :voucherbuyer
                :required? true
                :icon true
                :hide-email-helpers true})
             "buyeremail")]

          (when-not email?
            [:div
             (rum/with-key
               (forms/input "Re-enter your email address:" "e.g. jane.smith@domain.com"
                 (cmn/cursor-in voucher-atom [:voucher/buyeremailcheck])
                 {:type :email
                  :required? true
                  :icon true
                  :hide-email-helpers true})
               "buyeremailcheck")])

          (when-not email? [:input {:type "hidden" :name "conf[send]" :value "now"}])

          [:div.form-control

           (buttons/button-web
             (if
               (or voucher-id (:voucher/uuid voucher))
               "Update Voucher" "Preview Voucher")
             {:type :button
              :on-click
              (forms/form-validate node-atom
                #(grid/dispatch-action app-atom :web.gift-vouchers/validation-pre-preivew
                   (if email?
                     {:email-valid email
                      :confirm-email-valid confirmemail
                      :buyers-email buyeremail
                      :valid-date? valid-voucher-send-date?}
                     {:email-valid buyeremail
                      :confirm-email-valid buyeremailcheck
                      :valid-date? valid-voucher-send-date?})))
              :style :primary
              :size :large
              :icon :arrow-right
              :icon-placement :right})]]

         (toaster/loading-overlay app-atom :web.gift-vouchers/createvoucher)]]])))

(defn create-or-edit-helper [app-atom params]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom update :voucher
      (fn [voucher]
        (->
          voucher
          (assoc
            :voucher/method (:method params)
            :voucher/send (or (:voucher/send voucher) "now")
            :voucher/cover
            #:cover
             {:id (:coverid params)})
          (dissoc :voucher/fail-validation-reason))))
    (comms/ajax-get :web.gift-vouchers/get-cover {:coverid (:coverid params)})))

(defmethod comms/receive :web.gift-vouchers/get-cover [app-atom {:keys [cover]}]
  (toaster/close-overlay app-atom :web.gift-vouchers/createvoucher)
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom update :voucher assoc :voucher/cover cover)))

(defmethod flow/render-screen :web.gift-vouchers/createvoucher [app-atom _]
  (website/screen-wrapper app-atom
    (voucher-create app-atom)
    {}))

(defmethod t/transition-open :web.gift-vouchers/createvoucher [app-atom _ params]
  (toaster/open-overlay app-atom :web.gift-vouchers/createvoucher)
  (create-or-edit-helper app-atom params))

(defmethod flow/render-screen :web.gift-vouchers/editvoucher [app-atom _]
  (website/screen-wrapper app-atom
    (voucher-create app-atom)
    {}))

(defmethod t/transition-open :web.gift-vouchers/editvoucher [app-atom _ params]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher (cmn/curact process-atom :voucher)]
    (cond
      ;; New cart, can just get the details directly from the cart.
      (u/presence (:cartitem_uuid params))
      (let [cart-summary (cmn/curact app-atom [:cart-summary])
            rolled-up (model/roll-up-cart-items (:items cart-summary) (:variations cart-summary))
            item
            (->>
              rolled-up
              (filter #(contains? (set (:cartitem_uuids %)) (:cartitem_uuid params)))
              first)
            cover-voucher (:cover_voucher item)
            cover (get-in cart-summary [:covers (:cover_refid cover-voucher)])]
        (swap! process-atom assoc
          :cartitem/uuids (:cartitem_uuids item)
          :voucher
          #:voucher
           {:uuid (:uuid cover-voucher)
            :value (/ (:price item) 100)
            :email (:email cover-voucher)
            :confirmemail (:email cover-voucher)
            :name (:sender_name cover-voucher)
            :message (:message cover-voucher)
            :futuredate (:send_date cover-voucher)
            :buyeremail (:email cover-voucher)
            :buyeremailcheck (:email cover-voucher)
            :method (:method cover-voucher)
            :send (if (:future_send cover-voucher) "future" "now")
            :qty (:qty item)
            :cover
            #:cover
             {:id (:id cover)
              :ent/image
              #:doc
               {:public-id (:public_id (:image cover))}}}))

      (u/presence (:voucherid params))
      (do
        (toaster/open-overlay app-atom :web.gift-vouchers/createvoucher)
        (comms/ajax-get :web.gift-vouchers/fetch-voucher-details
          {:voucher-id (:voucherid params)
           :cover-id (:coverid params)
           :method (:method params)}))

      (nil? voucher)
      (urlstate/redirect app-atom "gift-vouchers" nil {}))))

(defmethod comms/receive :web.gift-vouchers/fetch-voucher-details [app-atom {:keys [voucher]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (toaster/close-overlay app-atom :web.gift-vouchers/createvoucher)
    (cond
      voucher
      (swap! process-atom assoc :voucher voucher)

      :else
      (do
        (urlstate/redirect app-atom "gift-vouchers" nil {})
        (toaster/open-toast app-atom :error "Voucher not found." {})))))